import { render } from "./OrdersTablePage.vue?vue&type=template&id=421ac78e&scoped=true"
import script from "./OrdersTablePage.vue?vue&type=script&lang=js"
export * from "./OrdersTablePage.vue?vue&type=script&lang=js"

import "./OrdersTablePage.vue?vue&type=style&index=0&id=421ac78e&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421ac78e"]])

export default __exports__